(function () {
  "use strict";

  const removeSlickRoles = () => {
    const slickDots = document.querySelectorAll(
      ".slick-dots li, .slick-dots li button"
    );
    slickDots.forEach((element) => {
      element.removeAttribute("role");
      element.setAttribute("tabindex", "-1");
      element.setAttribute("aria-hidden", "true");
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", removeSlickRoles);
  } else {
    removeSlickRoles();
  }

  const observer = new MutationObserver(() => {
    removeSlickRoles();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

document.addEventListener("DOMContentLoaded", function () {
  if (
    typeof $ === "undefined" &&
    !document.querySelector('script[src*="jquery"]')
  ) {
    const jqueryScript = document.createElement("script");
    jqueryScript.src = "https://code.jquery.com/jquery-3.6.0.min.js";
    jqueryScript.onload = loadSlick;
    document.head.appendChild(jqueryScript);
  } else {
    loadSlick();
  }

  function loadSlick() {
    if (!document.querySelector('script[src*="slick.min.js"]')) {
      const slickScript = document.createElement("script");
      slickScript.src =
        "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
      slickScript.onload = initSlickCarousel;
      document.head.appendChild(slickScript);
    } else {
      initSlickCarousel();
    }
  }

  function initSlickCarousel() {
    setTimeout(function () {
      if (typeof $ !== "undefined" && $.fn.slick) {
        const carousel = $(".product-images-carousel");
        const slideCount = carousel.find(".product-image-slide").length;

        carousel.slick({
          dots: slideCount > 1,
          infinite: slideCount > 1,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          arrows: slideCount > 1,
          swipeToSlide: false,
          touchMove: true,
          useCSS: false,
          useTransform: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: slideCount > 1,
              },
            },
          ],
        });

        if (slideCount > 1) {
          setTimeout(() => {
            carousel.slick("setPosition");
            carousel.slick("refresh");
          }, 100);

          setTimeout(() => {
            carousel.slick("setPosition");
          }, 200);
        }

        const relatedCarousel = $(".related-products-carousel");
        const relatedSlideCount = relatedCarousel.find(
          ".related-product-slide"
        ).length;

        if (relatedSlideCount > 0) {
          relatedCarousel.slick({
            dots: false,
            infinite: relatedSlideCount > 1,
            speed: 300,
            slidesToShow: 1.2,
            slidesToScroll: 1,
            arrows: false,
            swipeToSlide: true,
            touchMove: true,
            centerMode: false,
            variableWidth: false,
            responsive: [
              {
                breakpoint: 9999,
                settings: "unslick",
              },
              {
                breakpoint: 768,
                settings: {
                  dots: false,
                  infinite: relatedSlideCount > 1,
                  arrows: false,
                  slidesToShow: 1.2,
                  slidesToScroll: 1,
                  swipeToSlide: true,
                  touchMove: true,
                },
              },
            ],
          });
        }
      }
    }, 100);
  }

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (typeof $ !== "undefined" && $.fn.slick) {
        const relatedCarousel = $(".related-products-carousel");
        if (relatedCarousel.hasClass("slick-initialized")) {
          relatedCarousel.slick("resize");
        }
      }
    }, 250);
  });

  initVariantSelector();
  initProductDrawers();
  initSizeChartDrawer();
  initProductRecommendations();
  initStockists();

  function initVariantSelector() {
    const variantButtons = document.querySelectorAll(".variant-option");
    const variantIdInput = document.querySelector(".variant-id-input");
    const priceElement = document.querySelector(
      ".product-info div:nth-child(2)"
    );

    variantButtons.forEach((button) => {
      button.addEventListener("click", function () {
        variantButtons.forEach((btn) => {
          btn.classList.remove("selected", "font-bold");
          btn.setAttribute("aria-checked", "false");
          btn.setAttribute("tabindex", "-1");
        });

        this.classList.add("selected", "font-bold");
        this.setAttribute("aria-checked", "true");
        this.setAttribute("tabindex", "0");

        const variantId = this.getAttribute("data-variant-id");
        const variantPrice = this.getAttribute("data-variant-price");

        if (variantIdInput) {
          variantIdInput.value = variantId;
        }

        if (priceElement && variantPrice) {
          priceElement.textContent = variantPrice;
          priceElement.setAttribute("aria-label", `Price: ${variantPrice}`);
        }

        const variantTitle = this.textContent.trim();
        announceToScreenReader(
          `Selected variant: ${variantTitle}, ${variantPrice || ""}`
        );

        const fieldset = this.closest("fieldset");
        if (fieldset) {
          fieldset.setAttribute("aria-activedescendant", this.id || "");
        }

        const addToCartButton = document.querySelector('button[type="submit"]');
        const isAvailable = !this.hasAttribute("disabled");

        if (addToCartButton) {
          if (isAvailable) {
            addToCartButton.disabled = false;
            addToCartButton.textContent = "ADD TO CART";
            addToCartButton.className =
              "btn w-max cursor-pointer bg-black px-3 py-1 text-white hover:bg-gray-800 transition-colors duration-200";
          } else {
            addToCartButton.disabled = true;
            addToCartButton.textContent = "SOLD OUT";
            addToCartButton.className =
              "btn w-max cursor-not-allowed bg-gray-400 px-3 py-1 text-white";
          }
        }
      });

      button.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.click();
        }

        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          e.preventDefault();
          let nextButton = this.nextElementSibling;
          if (!nextButton) {
            nextButton = variantButtons[0];
          }
          nextButton.focus();
        }

        if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          e.preventDefault();
          let prevButton = this.previousElementSibling;
          if (!prevButton) {
            prevButton = variantButtons[variantButtons.length - 1];
          }
          prevButton.focus();
        }
      });
    });
  }

  function announceToScreenReader(message) {
    const announcement = document.createElement("div");
    announcement.setAttribute("aria-live", "polite");
    announcement.setAttribute("aria-atomic", "true");
    announcement.className = "sr-only";
    announcement.textContent = message;
    document.body.appendChild(announcement);

    setTimeout(() => {
      if (document.body.contains(announcement)) {
        document.body.removeChild(announcement);
      }
    }, 1000);
  }

  function initProductDrawers() {
    const drawerToggles = document.querySelectorAll(".drawer-toggle");

    drawerToggles.forEach((toggle) => {
      toggle.addEventListener("click", function () {
        const drawerId = this.getAttribute("data-drawer");
        const content = document.querySelector(
          `[data-drawer-content="${drawerId}"]`
        );
        const arrow = this.querySelector(".drawer-arrow");

        if (content && arrow) {
          const isOpen = !content.classList.contains("hidden");

          if (isOpen) {
            content.classList.add("hidden");
            arrow.classList.remove("rotate-180");
          } else {
            content.classList.remove("hidden");
            arrow.classList.add("rotate-180");
          }
        }
      });
    });
  }

  function initSizeChartDrawer() {
    const root = document.querySelector("[data-size-guide-root]");
    const trigger = document.querySelector("[data-size-guide-trigger]");
    const sizeChartButton = document.querySelector("[data-size-guide-button]");
    const drawer = root?.querySelector("[data-size-guide-drawer]");
    const overlay = root?.querySelector("[data-size-guide-overlay]");
    const closeButton = root?.querySelector("[data-size-guide-close]");
    const title = root?.querySelector("[data-size-guide-title]");
    const graphicContainer = root?.querySelector("[data-size-guide-graphic]");
    const tableContainer = root?.querySelector("[data-size-guide-table]");
    const notes = root?.querySelector("[data-size-guide-notes]");
    const modelSizing = root?.querySelector("[data-size-guide-model-sizing]");
    const sanity = window.GregRossSanity;

    if (
      !root ||
      !trigger ||
      !sizeChartButton ||
      !drawer ||
      !overlay ||
      !closeButton ||
      !title ||
      !graphicContainer ||
      !tableContainer ||
      !notes ||
      !modelSizing ||
      !sanity
    ) {
      return;
    }

    const config = sanity.readConfig(document.documentElement);
    const productGid = root.dataset.productGid;
    let previouslyFocused = null;

    if (!config || !productGid) {
      console.error("Sanity Size Guide configuration is incomplete.");
      return;
    }

    function appendTableCell(row, tagName, text, attributes) {
      const cell = document.createElement(tagName);

      cell.className =
        "border-b border-white px-3 py-2 text-center text-sm leading-tight";
      cell.textContent = text;

      Object.entries(attributes || {}).forEach(([name, value]) => {
        cell.setAttribute(name, value);
      });

      row.appendChild(cell);
    }

    function renderTable(sizeGuide) {
      const table = document.createElement("table");
      const caption = document.createElement("caption");
      const tableHead = document.createElement("thead");
      const headingRow = document.createElement("tr");
      const tableBody = document.createElement("tbody");

      table.className =
        "w-full border-separate border-spacing-0 overflow-hidden border border-white text-center text-sm";
      table.setAttribute("aria-label", `Size chart for ${sizeGuide.title}`);

      if (sizeGuide.columns.length > 3) {
        table.style.minWidth = "max-content";
      }

      caption.className = "sr-only";
      caption.textContent = `Size chart showing measurements for ${sizeGuide.title}.`;
      table.appendChild(caption);

      headingRow.className = "bg-white";
      appendTableCell(headingRow, "th", "SIZE", { scope: "col" });

      sizeGuide.columns.forEach((column) => {
        appendTableCell(headingRow, "th", column.title.toUpperCase(), {
          scope: "col",
        });
      });

      tableHead.appendChild(headingRow);
      table.appendChild(tableHead);

      sizeGuide.sizes.forEach((size, sizeIndex) => {
        const row = document.createElement("tr");

        row.className = "bg-white";
        appendTableCell(row, "th", size, { scope: "row" });

        sizeGuide.columns.forEach((column) => {
          appendTableCell(row, "td", column.values[sizeIndex].display);
        });

        tableBody.appendChild(row);
      });

      table.appendChild(tableBody);
      tableContainer.replaceChildren(table);
      tableContainer.style.overflowX = "auto";
    }

    function renderGraphic(sizeGuide) {
      graphicContainer.replaceChildren();
      graphicContainer.hidden = true;

      if (!sizeGuide.graphic) {
        return;
      }

      const imageUrl = sanity.buildImageUrl(sizeGuide.graphic, 600);

      if (!imageUrl) {
        return;
      }

      const image = document.createElement("img");

      image.className = "h-48 w-full object-contain object-center md:h-60";
      image.alt = sizeGuide.graphic.alt;
      image.draggable = false;
      image.loading = "eager";

      image.addEventListener(
        "load",
        function () {
          graphicContainer.hidden = false;
        },
        { once: true }
      );

      image.addEventListener(
        "error",
        function () {
          graphicContainer.replaceChildren();
          graphicContainer.hidden = true;
          console.error("Error loading Sanity Size Guide image.");
        },
        { once: true }
      );

      graphicContainer.replaceChildren(image);
      image.src = imageUrl;
    }

    function renderSizeGuide(sizeGuide, modelSizingNote) {
      title.textContent = `${sizeGuide.title.toUpperCase()} SIZE CHART`;
      renderGraphic(sizeGuide);
      renderTable(sizeGuide);

      notes.textContent = sizeGuide.notes;
      notes.hidden = !sizeGuide.notes;

      modelSizing.textContent = modelSizingNote;
      modelSizing.hidden = !modelSizingNote;
    }

    async function loadSizeGuide() {
      if (root.dataset.state) {
        return;
      }

      root.dataset.state = "loading";

      try {
        const content = await sanity.fetchProductContent(config, productGid);
        const sizeGuide = sanity.normalizeSizeGuide(content.sizeGuide);

        if (!sizeGuide) {
          root.dataset.state = "empty";
          return;
        }

        renderSizeGuide(sizeGuide, sanity.normalizeModelSizing(content.modelSizing));
        trigger.hidden = false;
        root.dataset.state = "ready";
      } catch (error) {
        root.dataset.state = "error";
        console.error("Error loading Sanity Size Guide:", error);
      }
    }

    function openSizeChart() {
      if (root.dataset.state !== "ready") {
        return;
      }

      previouslyFocused = document.activeElement;
      drawer.removeAttribute("inert");
      drawer.setAttribute("aria-hidden", "false");
      drawer.classList.remove("translate-x-full");
      drawer.classList.add("translate-x-0");
      overlay.hidden = false;
      overlay.setAttribute("aria-hidden", "false");
      sizeChartButton.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      closeButton.focus();
    }

    function closeSizeChart() {
      drawer.classList.remove("translate-x-0");
      drawer.classList.add("translate-x-full");
      drawer.setAttribute("aria-hidden", "true");
      drawer.setAttribute("inert", "");
      overlay.hidden = true;
      overlay.setAttribute("aria-hidden", "true");
      sizeChartButton.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";

      if (previouslyFocused instanceof HTMLElement) {
        previouslyFocused.focus();
      }
    }

    function trapDrawerFocus(event) {
      if (event.key !== "Tab" || drawer.hasAttribute("inert")) {
        return;
      }

      const focusable = Array.from(
        drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      );
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (!first || !last) {
        return;
      }

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    sizeChartButton.addEventListener("click", openSizeChart);
    closeButton.addEventListener("click", closeSizeChart);
    overlay.addEventListener("click", closeSizeChart);
    drawer.addEventListener("keydown", trapDrawerFocus);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !drawer.hasAttribute("inert")) {
        closeSizeChart();
      }
    });

    loadSizeGuide();
  }

  function initProductRecommendations() {
    const section = document.querySelector("[data-product-recommendations]");
    const grid = section?.querySelector("[data-product-recommendations-grid]");

    if (!section || !grid) {
      return;
    }

    const sanity = window.GregRossSanity;
    const config = sanity?.readConfig(document.documentElement);
    const productId = section.dataset.productId;
    const productGid = section.dataset.productGid;
    const productHandle = section.dataset.productHandle;
    const routesRoot = window.Shopify?.routes?.root || "/";
    const sectionId = "product-recommendations";
    const minimumCards = 3;

    async function fetchCards(url) {
      try {
        const response = await fetch(url, {
          headers: {
            Accept: "text/html",
          },
        });

        if (!response.ok) {
          return [];
        }

        const doc = new DOMParser().parseFromString(
          await response.text(),
          "text/html"
        );

        return Array.from(
          doc.querySelectorAll("[data-product-recommendation-card]")
        );
      } catch (error) {
        console.error("Error loading product recommendation cards:", error);
        return [];
      }
    }

    async function loadCuratedHandles() {
      if (!sanity || !config || !productGid) {
        return [];
      }

      try {
        const content = await sanity.fetchProductContent(config, productGid);

        return sanity.normalizeShopTheLook(content.shopTheLook, productGid);
      } catch (error) {
        console.error("Error loading Sanity Shop the Look:", error);
        return [];
      }
    }

    function reserveCards(count) {
      const placeholders = Array.from({ length: count }, () => {
        const placeholder = document.createElement("div");

        placeholder.className = "product-recommendations__placeholder";
        placeholder.setAttribute("aria-hidden", "true");

        return placeholder;
      });

      grid.replaceChildren(...placeholders);
    }

    function fetchRelatedCards() {
      return fetchCards(
        `${routesRoot}recommendations/products?product_id=${encodeURIComponent(productId)}&limit=6&intent=related&section_id=${sectionId}`
      );
    }

    async function loadRecommendations() {
      const handles = await loadCuratedHandles();

      reserveCards(Math.max(handles.length, minimumCards));

      const relatedRequest =
        handles.length < minimumCards ? fetchRelatedCards() : null;
      const curatedCards = (
        await Promise.all(
          handles.map((handle) =>
            fetchCards(
              `${routesRoot}products/${encodeURIComponent(handle)}?section_id=${sectionId}`
            )
          )
        )
      ).flat();
      const cards = [...curatedCards];

      if (cards.length < minimumCards) {
        const relatedCards = await (relatedRequest || fetchRelatedCards());
        const usedHandles = new Set(
          [productHandle, ...cards.map((card) => card.dataset.productHandle)].filter(
            Boolean
          )
        );

        for (const card of relatedCards) {
          if (cards.length >= minimumCards) {
            break;
          }

          const handle = card.dataset.productHandle;

          if (!handle || usedHandles.has(handle)) {
            continue;
          }

          usedHandles.add(handle);
          cards.push(card);
        }
      }

      section.setAttribute("aria-busy", "false");

      if (cards.length === 0) {
        section.style.display = "none";
        return;
      }

      grid.replaceChildren(...cards.map((card) => document.importNode(card, true)));

      requestAnimationFrame(() => {
        section.classList.remove("opacity-0");
        section.classList.add("opacity-100");
      });
    }

    loadRecommendations();
  }

  function initStockists() {
    const section = document.querySelector("[data-stockists]");
    const list = section?.querySelector("[data-stockists-list]");
    const status = section?.querySelector("[data-stockists-status]");
    const sanity = window.GregRossSanity;

    if (!section || !list || !status || !sanity) {
      return;
    }

    const config = sanity.readConfig(document.documentElement);

    if (!config) {
      status.textContent = section.dataset.errorMessage;
      return;
    }

    function getContinent(country) {
      const normalizedCountry = country.trim().toLowerCase();

      const continentMap = {
        // Europe
        italy: "Europe",
        france: "Europe",
        germany: "Europe",
        spain: "Europe",
        portugal: "Europe",
        netherlands: "Europe",
        belgium: "Europe",
        switzerland: "Europe",
        austria: "Europe",
        denmark: "Europe",
        sweden: "Europe",
        norway: "Europe",
        finland: "Europe",
        ireland: "Europe",
        "united kingdom": "Europe",
        uk: "Europe",
        england: "Europe",
        greece: "Europe",
        poland: "Europe",
        turkey: "Europe",
        russia: "Europe",
        luxembourg: "Europe",
        ukraine: "Europe",

        // Asia
        japan: "Asia",
        china: "Asia",
        "south korea": "Asia",
        korea: "Asia",
        singapore: "Asia",
        thailand: "Asia",
        taiwan: "Asia",
        hongkong: "Asia",
        "hong kong": "Asia",
        indonesia: "Asia",
        india: "Asia",
        malaysia: "Asia",

        // North America
        "united states": "North America",
        usa: "North America",
        "u.s.a.": "North America",
        canada: "North America",
        mexico: "North America",

        // South America
        brazil: "South America",
        argentina: "South America",
        chile: "South America",
        colombia: "South America",
        peru: "South America",

        // Oceania
        australia: "Oceania",
        "new zealand": "Oceania",

        // Africa
        "south africa": "Africa",
        egypt: "Africa",
        morocco: "Africa",
        nigeria: "Africa",
      };

      return continentMap[normalizedCountry] || "Other";
    }

    function toProperCase(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\b\w/g, (character) => character.toUpperCase());
    }

    function getCountryAbbreviation(country) {
      const normalizedCountry = country.trim().toLowerCase();

      const countryCodes = {
        // Europe
        italy: "IT",
        france: "FR",
        germany: "DE",
        spain: "ES",
        portugal: "PT",
        netherlands: "NL",
        belgium: "BE",
        switzerland: "CH",
        austria: "AT",
        denmark: "DK",
        sweden: "SE",
        norway: "NO",
        finland: "FI",
        ireland: "IE",
        "united kingdom": "UK",
        uk: "UK",
        england: "GB",
        greece: "GR",
        poland: "PL",
        turkey: "TR",
        russia: "RU",
        luxembourg: "LU",
        ukraine: "UA",

        // Asia
        japan: "JP",
        china: "CN",
        "south korea": "KR",
        korea: "KR",
        singapore: "SG",
        thailand: "TH",
        taiwan: "TW",
        hongkong: "HK",
        "hong kong": "HK",
        indonesia: "ID",
        india: "IN",
        malaysia: "MY",

        // North America
        "united states": "US",
        usa: "US",
        "u.s.a.": "US",
        canada: "CA",
        mexico: "MX",

        // South America
        brazil: "BR",
        argentina: "AR",
        chile: "CL",
        colombia: "CO",
        peru: "PE",

        // Oceania
        australia: "AU",
        "new zealand": "NZ",

        // Africa
        "south africa": "ZA",
        egypt: "EG",
        morocco: "MA",
        nigeria: "NG",
      };

      return countryCodes[normalizedCountry] || country.toUpperCase();
    }

    function renderStockists(stockists) {
      const fragment = document.createDocumentFragment();

      const continentOrder = [
        "North America",
        "South America",
        "Europe",
        "Asia",
        "Oceania",
        "Africa",
        "Other",
      ];

      const groupedStockists = {};

      stockists.forEach((stockist) => {
        const continent = getContinent(stockist.country);

        if (!groupedStockists[continent]) {
          groupedStockists[continent] = [];
        }

        groupedStockists[continent].push(stockist);
      });

      Object.values(groupedStockists).forEach((continentStockists) => {
        continentStockists.sort((a, b) => {
          return (
            a.country.localeCompare(b.country, undefined, {
              sensitivity: 'base',
            }) ||
            a.city.localeCompare(b.city, undefined, {
              sensitivity: 'base',
            }) ||
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
            })
          );
        });
      });

      continentOrder.forEach((continent) => {
        const continentStockists = groupedStockists[continent];

        if (!continentStockists?.length) {
          return;
        }

        const group = document.createElement("div");
        const heading = document.createElement("h2");
        const groupList = document.createElement("div");

        group.className = "stockists-continent-group";
        groupList.className = "stockists-continent-list";

        heading.className = "stockists-continent-heading";
        heading.textContent = continent;

        group.appendChild(heading);

        continentStockists.forEach((stockist) => {
          const row = document.createElement("div");
          const name = document.createElement("span");
          const location = document.createElement("span");
          const phone = document.createElement("span");
          const city = document.createElement("span");
          const country = document.createElement("span");

          row.className = "stockists-row";
          row.setAttribute("role", "listitem");

          row.setAttribute(
            "aria-label",
            `${stockist.name}, ${stockist.city}, ${stockist.country}, ${stockist.phone}`
          );

          name.className = "stockists-name";
          name.textContent = stockist.name;

          location.className = "stockists-location";
          location.textContent =
            `${toProperCase(stockist.city)}, ${getCountryAbbreviation(stockist.country)}`;

          city.className = "stockists-city";
          city.textContent = stockist.city;

          country.className = "stockists-country";
          country.textContent = stockist.country;

          phone.className = "stockists-phone";
          phone.textContent = stockist.phone;

          row.append(name, location, city, country, phone);
          groupList.appendChild(row);
        });

        group.appendChild(groupList);
        fragment.appendChild(group);
      });

      list.replaceChildren(fragment);
      list.hidden = false;
      status.hidden = true;
    }

    async function loadStockists() {
      try {
        const response = await fetch(
          sanity.buildQueryUrl(config, sanity.STOCKISTS_QUERY),
          {
            credentials: "omit",
            headers: {
              Accept: "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Sanity request failed with ${response.status}`);
        }

        const data = await response.json();
        const stockistReport = sanity.normalizeStockists(data.result);

        if (
          stockistReport.incomplete.length > 0 ||
          stockistReport.complete !== stockistReport.total
        ) {
          list.replaceChildren();
          list.hidden = true;
          status.hidden = false;
          status.textContent = section.dataset.errorMessage;
          console.error("Invalid Sanity Stockists dataset:", {
            total: stockistReport.total,
            complete: stockistReport.complete,
            incomplete: stockistReport.incomplete,
          });
          return;
        }

        if (stockistReport.total === 0) {
          status.textContent = section.dataset.emptyMessage;
          return;
        }

        renderStockists(stockistReport.stockists);
      } catch (error) {
        status.textContent = section.dataset.errorMessage;
        console.error("Error loading Sanity Stockists:", error);
      }
    }

    loadStockists();
  }

  initAddToCart();

  function initAddToCart() {
    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (productForm) {
      productForm.addEventListener("submit", function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        const addToCartButton = this.querySelector('button[type="submit"]');

        if (addToCartButton) {
          addToCartButton.disabled = true;
          addToCartButton.textContent = "ADDING...";
        }

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((item) => {
            const cartDrawer = document.querySelector(".cart-drawer");
            const cartOverlay = document.querySelector(".cart-drawer-overlay");

            if (cartDrawer && cartOverlay) {
              cartDrawer.classList.remove("translate-x-full");
              cartDrawer.classList.add("translate-x-0");
              cartOverlay.style.display = "block";
              document.body.style.overflow = "hidden";
            }

            fetch("/cart.js")
              .then((response) => response.json())
              .then((cart) => {
                updateCartDrawerContent(cart);
              });
          })
          .catch((error) => {
            console.error("Error adding to cart:", error);
            alert(
              "Sorry, there was an error adding this item to your cart. Please try again."
            );
          })
          .finally(() => {
            if (addToCartButton) {
              addToCartButton.disabled = false;
              addToCartButton.textContent = "ADD TO CART";
            }
          });
      });
    }
  }

  function updateCartDrawerContent(cart) {
    const subtotal = document.getElementById("cart-subtotal");
    if (subtotal) {
      subtotal.textContent = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(cart.total_price / 100);
    }

    const cartItemsList = document.querySelector(".cart-items-list");
    const cartEmptyState = document.querySelector(".cart-empty-state");
    const cartFooter = document.querySelector(".cart-drawer-footer");

    if (cart.item_count > 0) {
      if (cartItemsList) cartItemsList.classList.remove("hidden");
      if (cartEmptyState) cartEmptyState.classList.add("hidden");
      if (cartFooter) cartFooter.classList.remove("hidden");
    } else {
      if (cartItemsList) cartItemsList.classList.add("hidden");
      if (cartEmptyState) cartEmptyState.classList.remove("hidden");
      if (cartFooter) cartFooter.classList.add("hidden");
    }

    const cartDrawer = document.querySelector(".cart-drawer");
    const cartOverlay = document.querySelector(".cart-drawer-overlay");
    const isDrawerOpen =
      cartDrawer && !cartDrawer.classList.contains("translate-x-full");

    fetch("/?sections=header")
      .then((response) => response.json())
      .then((data) => {
        if (data.header) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data.header, "text/html");
          const newCartItems = doc.getElementById("cart-drawer-items");
          const newCartFooter = doc.querySelector(".cart-drawer-footer");
          const currentCartItems = document.getElementById("cart-drawer-items");
          if (newCartItems && currentCartItems) {
            currentCartItems.innerHTML = newCartItems.innerHTML;
          }
          const currentCartFooter = document.querySelector(
            ".cart-drawer-footer"
          );
          if (newCartFooter && currentCartFooter) {
            currentCartFooter.innerHTML = newCartFooter.innerHTML;
          }
          const updatedCartItemsList =
            document.querySelector(".cart-items-list");
          const updatedCartEmptyState =
            document.querySelector(".cart-empty-state");
          const updatedCartFooter = document.querySelector(
            ".cart-drawer-footer"
          );

          if (cart.item_count > 0) {
            if (updatedCartItemsList)
              updatedCartItemsList.classList.remove("hidden");
            if (updatedCartEmptyState)
              updatedCartEmptyState.classList.add("hidden");
            if (updatedCartFooter) updatedCartFooter.classList.remove("hidden");
          } else {
            if (updatedCartItemsList)
              updatedCartItemsList.classList.add("hidden");
            if (updatedCartEmptyState)
              updatedCartEmptyState.classList.remove("hidden");
            if (updatedCartFooter) updatedCartFooter.classList.add("hidden");
          }

          if (isDrawerOpen && cartDrawer && cartOverlay) {
            cartDrawer.classList.remove("translate-x-full");
            cartDrawer.classList.add("translate-x-0");
            cartOverlay.style.display = "block";
            document.body.style.overflow = "hidden";
          }
        }
      })
      .catch(() => {
        console.log(
          "Failed to update cart drawer, keeping it open without refresh"
        );
      });
  }

  window.updateCartDrawerContent = updateCartDrawerContent;
});
